import { UserDiscoData, UserDiscoContext } from '@disco/ui';
import { callApi } from '@disco/utils';
import { useCallback, useContext } from 'react';

export const useApi = () => {
  const { token } = useContext<UserDiscoData>(UserDiscoContext);
  return useCallback((url, options) => callApi(url, { token, ...options }), [token]);
};
